import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from '../../assets/Configuration';
import {
  PersonEventModel,
  PersonEventFlagType,
} from '../models/person/person-event.model';

@Injectable({
  providedIn: 'root',
})
export class PersonEventFlagService {
  constructor(private httpClient: HttpClient) {}

  public getPersonEventFlags(eventId: string): Observable<PersonEventModel[]> {
    return this.httpClient.get<PersonEventModel[]>(
      Configuration.getApiBaseUrl() + '/PersonEventFlag/by-event/' + eventId
    );
  }

  public getPersonAllEventsFlags(actionType: PersonEventFlagType): Observable<PersonEventModel[]> {
    const params = new HttpParams()
      .set('action', actionType.toString());

    return this.httpClient.get<PersonEventModel[]>(
      Configuration.getApiBaseUrl() + '/PersonEventFlag/by-action',
      { params: params }
    );
  }

  public addPersonEventFlag(
    eventId: string,
    actionType: PersonEventFlagType
  ): Observable<PersonEventModel> {
    
    const params = new HttpParams()
      .set('action', actionType.toString());
    
    return this.httpClient.post<PersonEventModel>(
      Configuration.getApiBaseUrl() + '/PersonEventFlag/by-event/' + eventId,
      {},
      { params: params }
    );
  }

  public deletePersonEventFlag(
    eventId: string,
    actionType: PersonEventFlagType
  ): Observable<PersonEventModel> {

    const params = new HttpParams()
      .set('action', actionType.toString());

    return this.httpClient.delete<PersonEventModel>(
      Configuration.getApiBaseUrl() + '/PersonEventFlag/by-event/' + eventId,
      { params: params }
    );
  }

  public deletePersonEventFlagCourseAssignment(
    eventId: string,
    employeeId: string,
  ): Observable<PersonEventModel> {
    return this.httpClient.post<PersonEventModel>(
      Configuration.getApiBaseUrl() +
        '/PersonEventFlag/by-event/' +
        eventId +
        '/by-person/' +
        employeeId +
        '/remove-course-assignment',
        {}
    );
  }
}
